function getDrawer(){
      fetch(cartPopupConfig.locale)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
          document.getElementById('shopify-section-cart-popup-2022').outerHTML = data['cart-popup-2022'];
          let lins = document.getElementsByClassName('li-notification');
          Array.prototype.forEach.call(lins, function(el) {
            let targetLIN = el.dataset.tokenLin;
            let allTargetLins = document.getElementsByClassName(targetLIN);
            let lastLin = allTargetLins[allTargetLins.length - 1];
            lastLin.classList.remove('hide');
          } );
          if( typeof triggerRuk_ratingSnippet !== 'undefined' ){
            triggerRuk_ratingSnippet();
          }
  
  
        /* Set height of the 
          var cartPopupContentContainer = this.selectors.cartPopupContentContainer;
        */
          var cartPopupWrapper = document.getElementById('shopify-section-cart-popup-2022').closest('.cart-popup');
          var selectors = {
            cartPopupHeader: '.cart-popup-header',
            cartPopupDeliver: '.cart-popup-delivery',
            cartPopupContentContainer: '.popup-content-container',
            cartPopupFooter: '.cart-popup-footer'
          };
          var cartPopupHeader = selectors.cartPopupHeader;
          var cartPopupDeliver = selectors.cartPopupDeliver;
          var cartPopupContentContainer = selectors.cartPopupContentContainer;
          var cartPopupFooter = selectors.cartPopupFooter; 
         
          if( typeof $(cartPopupWrapper).find(cartPopupContentContainer)[0] !== 'undefined'){
            var computedPadding = window.getComputedStyle( cartPopupWrapper );
            var occupiedSpace = ( 90 + parseFloat(computedPadding.paddingTop) + parseFloat(computedPadding.paddingBottom) + $(cartPopupWrapper).find(cartPopupHeader).outerHeight() + $(cartPopupWrapper).find(cartPopupDeliver).outerHeight() + $(cartPopupWrapper).find(cartPopupFooter).outerHeight() );
            var totalPotentialHeight = window.outerHeight - occupiedSpace;
            if( totalPotentialHeight > 0 ){
              $(cartPopupWrapper).find(cartPopupContentContainer).css({'max-height': totalPotentialHeight});
            }
          }          

          
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
            // Do something else here if there was an error
        });
}
document.addEventListener("DOMContentLoaded", () => {
  document.getElementById('cart-popup').addEventListener("updateContent", () => getDrawer() );
});
